import { provideHttpClient } from '@angular/common/http';
import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ClaimComponent } from './forms/claim/claim.component';

export const routes: Routes = [
  //   {
  //     path: '',
  //     component: HomeComponent,
  //   },
  {
    path: 'forms',
    children: [
      {
        path: 'claim',
        component: ClaimComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'forms/claim',
  },
];
